module.exports = __webpack_public_path__ + "static/media/keycloak.e89f301c.png";